module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAgCAYAAAB6kdqOAAAAAXNSR0IArs4c6QAAAPBJREFUWEftl+sNwjAMhK+TwCiMApMAkwCTwCZlFHRSg9oqD2PXqJXsn1WTfD6dY6fDyqJbGQ9+Ado7wr/T3lKgA4CnE9AdwEkL9ALwzcYISMWZqAnoCuBiBEnLk+oBVBJ0mwqROhf8fh4M+FB4iIUwL4amQnR9rzhMsoRlTfOOQwzETDQq5MB2AI7DPaMGmpShJP3KP4S5BVAoZPBReKglXigkVSg3RzXnodQ6PC7GGnhxHvIE4qGldjRpvOOZ2hMo11yzqgVQqwo2oRBNxjJdIlJpmzy0BMh8DxUQN/F6Losfl9KntIdqzbL/26G1gz61lX4hacGMKQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_maximize_y.png
// module id = Z8ec
// module chunks = 96